import { defineFeatureFlag, useBooleanFlag } from '@heidi/runtime/feature-flags';

// One switch per product, each the key the backend serve route also evaluates
// before it fills that product's formats. Keys are Flagsmith identities:
// renaming one switches flags.

/** Sponsored placements in Evidence: the home banner and both loading cards. */
export const evidenceAdsEnabledFlag = defineFeatureFlag({
  key: 'release-evidence-enable-ads',
  defaultValue: false,
  description: 'Sponsored placements in Evidence',
});

/** Sponsored placements in Scribe: the note-generation card. */
export const scribeAdsEnabledFlag = defineFeatureFlag({
  key: 'release-scribe-enable-ads',
  defaultValue: false,
  description: 'Sponsored placements in Scribe note generation',
});

export const useIsEvidenceAdsEnabled = (): boolean =>
  useBooleanFlag(evidenceAdsEnabledFlag.key, evidenceAdsEnabledFlag.defaultValue);

export const useIsScribeAdsEnabled = (): boolean =>
  useBooleanFlag(scribeAdsEnabledFlag.key, scribeAdsEnabledFlag.defaultValue);

/**
 * FE rollout gate for clinician (NPI) verification of existing US users.
 * Defaults OFF; the backend gate on `/hcp-verifications` stays the source of
 * truth for eligibility.
 */
export const userHcpVerificationFlag = defineFeatureFlag({
  key: 'release-user-hcp-verification',
  defaultValue: false,
  description: 'Clinician (NPI) verification of existing US users',
});

export const useIsUserHcpVerificationEnabled = (): boolean =>
  useBooleanFlag(userHcpVerificationFlag.key, userHcpVerificationFlag.defaultValue);
